import { t } from '@/plugins/i18n'
export const columns: any = [
  {
    label: t('商品图片'),
    prop: 'combinationProductMainImg',
    slotName: 'combinationProductMainImg',
    align: 'center'
  },
  {
    label: t('客户商品sku'),
    prop: 'customerProductMsku',
    align: 'center',
    slotName: 'customerProductMsku',
    width: 140
  },
  {
    label: t('组合商品SKU'),
    prop: 'combinationProductSku',
    slotName: 'combinationProductSku',
    align: 'center'
  },
  {
    label: t('组合商品名称'),
    prop: 'combinationProductName',
    align: 'center'
  },
  {
    label: t('组合附加项'),
    prop: 'combinationProductAdditionList',
    align: 'center',
    slotName: 'combinationProductAdditionList'
  },
  {
    label: t('组合商品规格'),
    prop: 'combinationProductProp',
    align: 'center'
  },
  // {
  //   label: t('商品国家'),
  //   prop: 'goodsCountry',
  //   align: 'center',
  //   slotName: 'goodsCountry',
  //   isMultiStore: true
  // },
  {
    label: t('单价'),
    prop: 'productSellPrice',
    align: 'center',
    slotName: 'productSellPrice'
  },
  {
    label: t('创建时间'),
    prop: 'createTime',
    align: 'center',
    slotName: 'createTime'
  }
]

export const childColumns: any = [
  {
    label: t('图片'),
    align: 'center',
    slotName: 'productSkuImg'
  },
  {
    label: t('商品名称'),
    prop: 'productTitle',
    width: 180,
    align: 'center',
    slotName: 'productTitle'
  },
  {
    label: t('商品SKU'),
    prop: 'productSku',
    width: 180,
    align: 'center'
  },
  {
    label: t('商品采购国家'),
    prop: 'purchaseCountry',
    align: 'center',
    slotName: 'purchaseCountry'
  },
  {
    label: t('规格'),
    prop: 'productPropertiesName',
    align: 'center',
    slotName: 'productPropertiesName'
  },
  {
    label: t('商品附加项'),
    prop: 'addition',
    align: 'center',
    slotName: 'addition'
  },
  {
    label: t('单价'),
    prop: 'productSellPrice',
    align: 'center',
    slotName: 'productSellPrice'
  },
  {
    label: t('单组数量'),
    width: 160,
    prop: 'unitNums',
    align: 'center'
  },
  {
    label: t('小计'),
    prop: 'Subtotal',
    align: 'center',
    slotName: 'Subtotal'
  },
  {
    label: t('待组合库存数量（截止时间）'),
    width: 300,
    slotName: 'remainCombinationProductItemRespList'
  }
]

export const tableConfig = {
  showSelection: true,
  showHandler: true,
  showExpand: true,
  setHeight: true,
  rowKey: 'combinationProductId',
  height: 600
}

export const childConfig = {
  showHandler: true,
  handlerConfig: { label: ' ' }
}
